import { Grid } from "@mui/material"
import { useState } from "react"
import CourseCard from "../cards/CourseCard"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../ui/TabPanel"
import ClassesTab from "../course/ClassesTab"
import NotesTab from "../course/NotesTab"
import AssignmentsTab from "../course/AssignmentsTab"
import StudentsTab from "../course/StudentsTab"
import { useEffect } from "react"
import AddCourseModal from "../modals/AddCourseModal"
import DeleteCourseModal from "../modals/DeleteCourseModal"
import AddBatchModal from "../modals/AddBatchModal"
import { getBatches, getCourseStats } from "../../api"
import { useSnackbar } from "notistack"
import { useParams } from "react-router-dom"
import LoadingContent from "../common/LoadingContent"
import DiscussionTab from "../course/DiscussionTab"
import AddClassSchedule from "../modals/AddClassSchedule"

const Course = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [course, setCourse] = useState()
  const [batches, setBatches] = useState([])
  const [loading, setLoading] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)
  const changeTab = (_, newValue) => setTabIndex(newValue)
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [batchModal, setBatchModal] = useState(false)
  const { id } = useParams()
  const [classScheduleModal, setClassScheduleModal] = useState(false)
  const [selectedBatch, setSelectedBatch] = useState(0)

  const openEditModal = () => setEditModal(true)
  const closeEditModal = () => setEditModal(false)
  const openDeleteModal = () => setDeleteModal(true)
  const closeDeleteModal = () => setDeleteModal(false)
  const openClassScheduleModal = () => setClassScheduleModal(true)
  const closeClassScheduleModal = () => setClassScheduleModal(false)

  const fetchCourse = () => {
    setLoading(true)
    getCourseStats(id)
      .then((res) => {
        //console.log(res.data.data);
        setCourse(res.data.data)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  const fetchBatches = () => {
    setLoading(true)
    getBatches({filter: {courseId: id}})
      .then((res) => {
        setBatches(res.data.rows)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchCourse()
    fetchBatches()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LoadingContent loading={loading}>
          {course && (
            <CourseCard
              data={course}
              showBatches
              batches={batches}
              edit={openEditModal}
              deleteCourse={openDeleteModal}
              addBatch={() => setBatchModal(true)}
              selectedBatch={selectedBatch}
              setSelectedBatch={setSelectedBatch}
            />
          )}
        </LoadingContent>
      </Grid>
      <Grid item xs={8}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabIndex} onChange={changeTab}>
            <Tab label="Classes" />
            <Tab label="Notes" />
            <Tab label="Assignments" />
            <Tab label="Students" />
            <Tab label="Discussion" />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <ClassesTab batchId={batches[selectedBatch]?.id} />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <NotesTab batchId={batches[selectedBatch]?.id} />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <AssignmentsTab batchId={batches[selectedBatch]?.id} />
        </TabPanel>
        <TabPanel value={tabIndex} index={3}>
          <StudentsTab batchData={batches[selectedBatch]} />
        </TabPanel>
        <TabPanel value={tabIndex} index={4}>
          <DiscussionTab batchId={batches[selectedBatch]?.id} />
        </TabPanel>
      </Grid>
      <AddCourseModal
        isOpen={editModal}
        close={closeEditModal}
        course={course}
      />
      <DeleteCourseModal
        isOpen={deleteModal}
        close={closeDeleteModal}
        course={course}
      />
      <AddBatchModal
        isOpen={batchModal}
        close={() => setBatchModal(false)}
        refresh={fetchBatches}
        openClassSchedule={openClassScheduleModal}
        setBatch={setSelectedBatch}
      />
      <AddClassSchedule
        isOpen={classScheduleModal}
        close={closeClassScheduleModal}
        batchId={batches[selectedBatch]?.id}
        batchName={batches[selectedBatch]?.name}
      />
    </Grid>
  )
}

export default Course
